import { sha3_256 } from "js-sha3"
import { toB58String, encode } from "multihashes"
import strictjson from "json-stable-stringify"

export const fileHash = (filename: Blob) => {
	return new Promise((resolve, reject) => {
		const hash = sha3_256.create()
		const reader = new FileReader()
		reader.addEventListener("loadend", () => {
			console.log("reader.result", reader.result)
			hash.update(reader.result)
			const buf = Buffer.from(hash.hex(), "hex")
			resolve(toB58String(encode(buf, "sha3-256")))
			return
		})
		reader.readAsArrayBuffer(filename)
		return
	})
}

export const jsonHash = <T extends Record<string, unknown>>(json_data: T): string => {
	const stringifyData = strictjson(json_data, (a, b) => (a.key > b.key ? 1 : -1))
	return sha3_256.create().update(stringifyData).hex()
}
